import type { RootState } from 'types/root-state';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.spl.catalogueContent || initialState;

export const selectSelectedFilterItems = (state: RootState) =>
	selectDomain(state).selectedFilterItems;

export const selectFilterModalState = (state: RootState) => selectDomain(state).isModalOpen;
